/**
 * @generated SignedSource<<795cad6552b5786ac489242c6a70e4f5>>
 * @relayHash 375208eee06e531e31912b7a419f44d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307

import type { ConcreteRequest } from 'relay-runtime';
export type RecentFilter = "ALL" | "COLLABORATED_ON" | "CREATED" | "WORKED_ON" | "%future added value";
export type useRecentPreferencesHomeRecentUserPreferencesQuery$variables = Record<PropertyKey, never>;
export type useRecentPreferencesHomeRecentUserPreferencesQuery$data = {
  readonly userPreferences: {
    readonly recentFilter: RecentFilter;
  } | null | undefined;
};
export type useRecentPreferencesHomeRecentUserPreferencesQuery = {
  response: useRecentPreferencesHomeRecentUserPreferencesQuery$data;
  variables: useRecentPreferencesHomeRecentUserPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "recentFilter"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "375208eee06e531e31912b7a419f44d0",
    "id": "6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307",
    "metadata": {},
    "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
    "operationKind": "query",
    "text": "query useRecentPreferencesHomeRecentUserPreferencesQuery{userPreferences{recentFilter}}"
  }
};
})();

(node as any).hash = "7467140cd6c953941675ec5eab0f0de2";

export default node;
